module.exports = __webpack_public_path__ + "ida_design_awards_moodboard_photography_fashion_graphic_design_logo_design.jpg?f783b3f16d50cd73762723b4318a5068";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_design_awards_moodboard_photography_fashion_graphic_design_logo_design.jpg
// module id = 66
// module chunks = 0